<template>

  <el-dialog v-model="dialogVisible" title="闹钟提醒" :close-on-click-modal="false" :close-on-press-escape="false" width="700">
    <el-table :data="alarmClockList" style="width: 100%">
      <el-table-column prop="start_date" label="开始日期" width="150"/>
      <el-table-column prop="end_date" label="结束日期" width="150"/>
      <el-table-column prop="warn_content" label="提示内容" />
    </el-table>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="closeDialog()">确认</el-button>
      </div>
    </template>
  </el-dialog>

  <div class="group">
    <div class="group-item" v-for="item in groupList" :key="item.id">
      <div class="title">{{ item.name }}</div>
      <GroupAppItem :item="item"/>
    </div>
  </div>
</template>


<script>
import GroupAppItem from "@/views/GroupAppItem.vue";

export default {
  name: "GroupDesktop",
  components: {GroupAppItem},
  computed: {
    groupList() {
      let icons = []
      this.$store.state.core.applications.forEach(item => {
        icons.push(item)
      })
      return icons;
    },

  },
  data() {
    return {
      dialogVisible: false,
      alarmClockList: [],
    }
  },
  created() {
    this.getAlarmClock()
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },

    //获取自己的闹钟
    async getAlarmClock() {
      this.alarmClockList = await this.$http('alarmClockService.getAlarmClock', {})
      if (this.alarmClockList.length > 0){
        this.dialogVisible = true
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import 'node_modules/joysun-frame/packages/css/global.less';

.group {
  color: #FFFFFF;
  display: flex;
  position: absolute;
  top: @taskHeight;
  flex-wrap: wrap;
  width: 1400px;

  .group-item {
    width: 442px;
    height: 360px;
    margin: 14px 7px 0;
    background-color: rgba(0, 48, 100, 0.4);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .title {
      background-color: rgba(66, 85, 101, 0.2);
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      line-height: 38px;
      border-top-left-radius: inherit;
      border-top-right-radius: inherit;
    }
  }

}
</style>